import qs from 'qs';
import fileDownload from 'js-file-download';
import { showToast } from 'stores/ToastStore';
import client from './rest/AdminClient';

export const getShipperWarehouseRelation = async (status, active) => {
  const queryString = qs.stringify({
    status,
    active,
  });
  return client({
    method: 'GET',
    path: `/api/v2/warehouse/shipper-relation?${queryString}`,
  });
};

export const submitEmptyNotifyContainersRequest = async (body) => {
  return client({
    method: 'POST',
    path: `api/v2/warehouse/enqueue-containers`,
    entity: JSON.stringify(body),
  });
};

export const getEmptyNotifyContainersRequests = async (
  reportId,
  skip,
  limit,
) => {
  return client({
    method: 'GET',
    path: `/api/v2/warehouse/report/${reportId}?skip=${skip}&limit=${limit}`,
  });
};

export const downloadCsvEmptyNotifyRequests = async (reportId) => {
  try {
    const response = await client({
      method: 'POST',
      path: `/api/v2/warehouse/report/${reportId}/download`,
    });
    fileDownload(response.entity, 'empty-notify-containers.csv');
  } catch (e) {
    let errorMessage = typeof e === 'string' ? e : e.message;
    showToast('', errorMessage, 'error');
  }
};

export const checkExistingWarehouse = async (locationId) => {
  const queryString = qs.stringify({ location: locationId });
  try {
    const response = await client({
      method: 'GET',
      path: '/admin/api/v2/warehouse/check_active_warehouse?' + queryString,
    });
    return response.entity;
  } catch (e) {
    let errorMessage = typeof e === 'string' ? e : e.message;
    showToast('', errorMessage, 'error');
  }
};
